import React from 'react'

export default function Logo() {
  return <img src='/logo.png' alt='Operations Logo' height={120} />
}
